import supabase from "artifact/supabase";
import Input, { style } from "element/input";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-set-new-password")
class SetNewPassword extends Input {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <m-new-password class='${style.form__input}' required></m-new-password>
        <button class='${style.form__button}'>Redefinir senha</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.onSubmit](formData) {
    const { data, error } = await supabase.auth.updateUser(formData);
    error ? alert(error.message) : location.assign("/oauth/password-reseted");
    return this;
  }
}

export default SetNewPassword;
